module.exports = __webpack_public_path__ + "static/media/laucher_3_bg.9eadee87.jpg";